import { render, staticRenderFns } from "./DfFooter.vue?vue&type=template&id=1000117e&scoped=true&"
import script from "./DfFooter.vue?vue&type=script&lang=js&"
export * from "./DfFooter.vue?vue&type=script&lang=js&"
import style0 from "./DfFooter.vue?vue&type=style&index=0&id=1000117e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1000117e",
  null
  
)

export default component.exports